import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REPORTS_BASE_URL, ITEMS_SALES_REPORT_API } from "../../../../Constants/Config";

const initialState = {
    loading: false,
    loadingMore: false,
    salesItemsData: [],
    netSale: 0,
    totalSold: 0,
    totalItems: 0,
    totalGrossSales: 0,
    page: 1,
    pageSize: 100,
    hasMore: false,
    status: false,
    successMessage: "",
    error: "",
};

export const fetchSalesItemsData = createAsyncThunk(
    "SalesItemNew/fetchSalesItemsData",
    async (data, { rejectWithValue }) => {
        try {
            const { token, append, ...dataNew } = data;

            const response = await axios.post(
                REPORTS_BASE_URL + ITEMS_SALES_REPORT_API,
                dataNew,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status === true) {
                return {
                    items: response.data.item_sale_data || [],
                    netSale: response.data.net_sale ?? 0,
                    totalSold: response.data.total_sold ?? 0,
                    totalItems: response.data.total_items ?? 0,
                    totalGrossSales: response.data.total_gross_sales ?? 0,
                    page: response.data.page ?? 1,
                    pageSize: response.data.page_size ?? 100,
                    hasMore: Boolean(response.data.has_more),
                    status: response.data.status,
                    append: Boolean(append),
                };
            }

            return rejectWithValue({
                message: response.data.message || "Failed to fetch data",
                status: response.status,
                data: response.data,
            });
        } catch (error) {
            const customError = {
                message: error.message,
                status: error.response ? error.response.status : "Network Error",
                data: error.response ? error.response.data : null,
            };
            return rejectWithValue(customError);
        }
    }
);

const SalesItemNewSlice = createSlice({
    name: "SalesItemNew",
    initialState,
    reducers: {
        clearSalesItemsData: (state) => {
            state.salesItemsData = [];
            state.netSale = 0;
            state.totalSold = 0;
            state.totalItems = 0;
            state.totalGrossSales = 0;
            state.page = 1;
            state.hasMore = false;
            state.status = false;
            state.loading = false;
            state.loadingMore = false;
            state.error = "";
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSalesItemsData.pending, (state, action) => {
            if (action.meta.arg?.append) {
                state.loadingMore = true;
            } else {
                state.loading = true;
            }
        });
        builder.addCase(fetchSalesItemsData.fulfilled, (state, action) => {
            state.loading = false;
            state.loadingMore = false;
            const payload = action.payload || {};
            if (payload.append) {
                const newItems = payload.items || [];
                state.salesItemsData = [...state.salesItemsData, ...newItems];
                if (newItems.length === 0) {
                    state.hasMore = false;
                }
            } else {
                state.salesItemsData = payload.items || [];
            }
            if (!payload.append || payload.page === 1) {
                state.netSale = payload.netSale ?? state.netSale;
                state.totalSold = payload.totalSold ?? state.totalSold;
                state.totalItems = payload.totalItems ?? 0;
                state.totalGrossSales = payload.totalGrossSales ?? 0;
            }
            state.page = payload.page ?? 1;
            state.pageSize = payload.pageSize ?? 100;
            state.hasMore = payload.hasMore ?? false;
            state.status = payload.status ?? false;
            state.error = "";
        });
        builder.addCase(fetchSalesItemsData.rejected, (state, action) => {
            state.loading = false;
            state.loadingMore = false;
            if (action.meta.arg?.append) {
                state.hasMore = false;
            } else {
                state.salesItemsData = [];
                state.status = false;
            }
            state.error = action.error?.message || "Request failed";
        });
    },
});

export const { clearSalesItemsData } = SalesItemNewSlice.actions;
export default SalesItemNewSlice.reducer;
